import { render, staticRenderFns } from "./ProjectTaskView.vue?vue&type=template&id=84012bc0&scoped=true&"
import script from "./ProjectTaskView.vue?vue&type=script&setup=true&lang=js&"
export * from "./ProjectTaskView.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./ProjectTaskView.vue?vue&type=style&index=0&id=84012bc0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84012bc0",
  null
  
)

export default component.exports